import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const PageHero = ({ eyebrow, title, copy, image, alt, ctaText, ctaTo = "/contact", note, testId, imgPosition = "object-[50%_60%]" }) => (
  <section className="relative min-h-[58vh] flex items-end" data-testid={testId}>
    <div className="absolute inset-0">
      <img src={image} alt={alt} className={`w-full h-full object-cover ${imgPosition}`} />
      <div className="absolute inset-0 bg-gradient-to-t from-[#1E241B]/85 via-[#1E241B]/35 to-[#1E241B]/15" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#1E241B]/40 to-transparent" />
    </div>
    <div className="relative w-full max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pb-14 pt-36">
      {eyebrow && <p className="eyebrow-light" data-testid={`${testId}-eyebrow`}>{eyebrow}</p>}
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-medium text-[#F7F4ED] tracking-tight leading-[1.08] mt-4 max-w-3xl" data-testid={`${testId}-heading`}>
        {title}
      </h1>
      {copy && <p className="mt-5 max-w-xl text-base sm:text-lg leading-relaxed text-[#F7F4ED]/85">{copy}</p>}
      <div className="mt-8 flex flex-wrap items-center gap-5">
        {ctaText && (
          <Link
            to={ctaTo}
            data-testid={`${testId}-cta-button`}
            className="inline-flex items-center gap-2 rounded-full bg-[#F7F4ED] text-[#292A26] px-7 py-3.5 text-sm font-semibold hover:bg-white transition-colors"
          >
            {ctaText}
            <ArrowRight className="w-4 h-4" />
          </Link>
        )}
        {note && <span className="text-xs uppercase tracking-[0.18em] text-[#F7F4ED]/75 font-medium" data-testid={`${testId}-note`}>{note}</span>}
      </div>
    </div>
  </section>
);
